import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  container: {
    height: '430px',
    overflow: 'scroll',
    alignContent: 'start'
  },
  item: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'start',
    alignItems: 'center',
    width: '100%',
    height: '50px',
  },
  itemTextField: {
    padding: '5px 15px',
  },
  itemWithRadioGroup: {
    padding: '15px',
  },
  itemHeaderRow: {
    justifyContent: 'space-between',
  },
  label: {
    marginRight: '5px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '14px',
  },
  itemIdTypeRow: {
    paddingBottom: '25px',
  },
  subtitle: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: '11px',
    width: '90%',
    padding: '5px 0px 5px 2px',
  },
  TripleSwitch: {
    marginLeft: '25px',
    marginBottom: '6px',
  },
  filterState: {
    display: 'flex',
    alignItems: 'center',
    height: '35px',
    backgroundColor: 'rgba(60, 65, 154, 0.1)',
    flexWrap: 'wrap',
  },
  filterStateText: {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '13px',
    padding: '0px 15px',
    cursor: 'pointer'
  },
  filterStateActionText: {
    color: '#3C419A',
  },
  line: {
    position: 'relative',
    width: '99%',
    size: '0px',
    color: '#2c2d3e',
    opacity: 0.5,
    display: 'inline-block',
    margin: '13px 0px',
  },
}));
